import styles from "./WhatIsIEEE.module.css"
import GroupImg from "assets/images/svg/Group.svg";

const WhatIsIEEE = () => {
  return (
    <section className={styles.section}>
        <div className={styles.content}>
          <div className={styles.textContent}>
            <h2 className={styles.title}>What is IEEE</h2>
            <p className={styles.description}>
              IEEE, an organization dedicated to advancing innovation and technological excellence for the benefit of
              humanity, is the world's largest technical professional society. It is designed to serve professionals
              involved in all aspects of the electrical, electronic, and computing fields and related areas of science
              and technology that underlie modern civilization.
            </p>
            <div className={styles.stats}>
              <div className={styles.statItem}>
                <div className={styles.statNumber}>+1200</div>
                <div className={styles.statLabel}>Conference</div>
              </div>
              <div className={styles.statItem}>
                <div className={styles.statNumber}>+200</div>
                <div className={styles.statLabel}>Journals, Magazines</div>
              </div>
            </div>
          </div>
          <div className={styles.imageWrapper}>
            <img src={GroupImg} alt="IEEE Illustration" className={styles.image} />
          </div>
        </div>
    </section>
  )
}

export default WhatIsIEEE

